import { ELMA365ToolAction } from '../../../../gamma-api';

export const getToolActionTypeDisplayText = (
  toolAction: ELMA365ToolAction,
  translate: (key: string) => string
): string => {
  return translate(`Toolkits: ELMA365: Actions: ${toolAction}`);
};
